import { Component, OnInit } from '@angular/core';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { EtenderService } from 'src/app/shared/services/etender.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-delete-tender',
  templateUrl: './delete-tender.component.html',
  styles: []
})
export class DeleteTenderComponent implements OnInit {
  tenderId: string;
  showRequest = false;
  constructor(private route: ActivatedRoute,private alertService: AlertService,
    private etenderSrv: EtenderService) {
    this.tenderId = this.route.snapshot.params.Id;
    if (this.tenderId) {

      this.etenderSrv.DeleteTender(this.tenderId).subscribe(d => {
        if (d.Success) {
          this.showRequest = true;
        }
        else {

          this.showRequest = false;
          this.alertService.error(d.ErrorMessages[0]);
        }
      });
    }
  }
  ngOnInit() {
  }

}
